<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Version List</el-breadcrumb-item>
    </el-breadcrumb>
    <p></p>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60"></el-table-column> -->
      <el-table-column align="center" prop="version" label="software Version" width="200"></el-table-column>
      <el-table-column align="center" prop="creationTime" label="Creation Time" width="200"></el-table-column>
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column align="center" label="Lastest Software version" fixed="right" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="update(scope.$index, scope.row)" type="primary">Update</el-button>
          <el-button size="mini" @click="checkMachine(scope.$index, scope.row)" type="primary">Check Machine</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :title="title" :visible.sync="machineFormVisible" width="20%" @click="closeDialog">
      <el-table size="small" :data="machineList" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
        <el-table-column align="center" type="index" width="30"></el-table-column>
        <el-table-column fit align="center" prop="softwareSerialNumber" label="Machine S/N" width="190"></el-table-column>
      </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-dialog>
  </div>
</template>

<script>
import { getVersion, getMachineData, editMachine } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      machineFormVisible: false,
      title: '',
      machineList: [],
      listData: [],
      formInline: {
        page: 1
      },
      machineFormInline: {
        page: 1,
        serialNumber: '',
        machineName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        assignBelongingText: '',
        status: '',
        version: '',
        rentalTime: '',
        creationTime: '',
        lastOnlineTime: ''
      },
      // 分页参数
      pageparm: {
        page: 1,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getVersionList(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getVersionList(parameter) {
      this.loading = true
      getVersion(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.listData = res.data;
            // 分页赋值
            this.pageparm.page = this.formInline.page;
            this.pageparm.total = res.total;
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Menu failed to load, please try again later！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    checkMachine(index,row){
      this.machineFormInline.version = row.version;
      console.log(this.machineFormInline);
      getMachineData(this.machineFormInline)
        .then(res => {
          if(res.code === 201){
            console.log(res);
          }
        })
      this.machineFormVisible = true;
    },
    update(index,row){
      console.log(index,row);
      var obj = {version:row.version}
      editMachine(obj)
        .then(res => {
          if(res.code === 201){
            console.log(res);
          }
        })
    },
    // 关闭弹出框
    closeDialog() {
      this.historyFormVisible = false;
      this.parametersFormVisible = false;
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/version.vue